var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIconOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_482_13850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33398 5.83268C2.01182 5.83268 1.75065 6.09385 1.75065 6.41602V11.666C1.75065 11.9882 2.01182 12.2493 2.33398 12.2493H7.58398C7.90615 12.2493 8.16732 11.9882 8.16732 11.666V6.41602C8.16732 6.09385 7.90615 5.83268 7.58398 5.83268H2.33398ZM0.583984 6.41602C0.583984 5.44952 1.36749 4.66602 2.33398 4.66602H7.58398C8.55048 4.66602 9.33398 5.44952 9.33398 6.41602V11.666C9.33398 12.6325 8.55048 13.416 7.58398 13.416H2.33398C1.36749 13.416 0.583984 12.6325 0.583984 11.666V6.41602Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.666 1.75065C11.8207 1.75065 11.9691 1.81211 12.0785 1.92151C12.1879 2.0309 12.2493 2.17927 12.2493 2.33398V7.58398C12.2493 7.73869 12.1879 7.88707 12.0785 7.99646C11.9691 8.10586 11.8207 8.16732 11.666 8.16732H11.0827C10.7605 8.16732 10.4993 8.42848 10.4993 8.75065C10.4993 9.07282 10.7605 9.33398 11.0827 9.33398H11.666C12.1301 9.33398 12.5753 9.14961 12.9035 8.82142C13.2316 8.49323 13.416 8.04811 13.416 7.58398V2.33398C13.416 1.86986 13.2316 1.42474 12.9035 1.09655C12.5753 0.768359 12.1301 0.583984 11.666 0.583984H6.41602C5.95189 0.583984 5.50677 0.768359 5.17858 1.09655C4.85039 1.42474 4.66602 1.86986 4.66602 2.33398V2.91732C4.66602 3.23948 4.92718 3.50065 5.24935 3.50065C5.57152 3.50065 5.83268 3.23948 5.83268 2.91732V2.33398C5.83268 2.17927 5.89414 2.0309 6.00354 1.92151C6.11293 1.81211 6.26131 1.75065 6.41602 1.75065H11.666Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_13850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconOutlined);
export default __webpack_public_path__ + "static/media/copy-icon-outlined.c0544c5280c5a6e030545a22036576cd.svg";
export { ForwardRef as ReactComponent };